<template>
  <b-card>
    
    <div>
      <b-dropdown
        class="dropdown float-right mr-50"
        :text="filtroDias.data"
        size="sm"
        variant="outline-primary"
      >
        <b-dropdown-item
          v-for="(tipo, index) in dias"
          :key="index"
          @click="alterouFiltroDias(tipo)"
        >
          {{ tipo.nome }}
        </b-dropdown-item>
      </b-dropdown>
      
      <b-dropdown
        class="dropdown float-right mr-50"
        :text="filtroAssinantes.data"
        size="sm"
        variant="outline-primary"
      >
        <b-dropdown-item
          v-for="(tipo, index) in assinantes"
          :key="index"
          @click="alterouFiltroAssinantes(tipo)"
        >
          {{ tipo.nome }}
        </b-dropdown-item>
      </b-dropdown>
      <h4>Inatividade (não lançou OS)</h4>
      
      <h2 class="font-weight-bolder mb-1">
        {{ items.length }}
      </h2>
      
      <div>
        <b-row>
          <b-button
            class="mx-1"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-primary"
            size="sm"
            @click="clicouVisualizar = !clicouVisualizar"
          >
            Visualizar
          </b-button>
        
        
        </b-row>
      </div>
    </div>
    
    <div v-if="clicouVisualizar" class="listaServicos">
      <hr class="mb-0" />
      <b-list-group flush>
        <b-list-group-item
          class="pb-0"
          v-for="(item, index) in items"
          :key="index"
        >
          <b-row class="font-small-3" :id="`popover-vencendo-info-${index}`">
            <b-col md="2" class="pr-0">
              <span>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  class="btn-icon"
                  :pressed="true"
                  :variant="
                    item.data_expiracao === $getDate.hoje()
                      ? 'flat-danger'
                      : 'flat-warning'
                  "
                >
                  <span>{{ item.id_company }}</span>
                </b-button>
              </span>
            </b-col>
            <b-col md="10">
              <ul class="list-unstyled">
                <li><strong>Nome</strong>: {{ item.nome }}</li>
                <li><strong>Tel Comercial:</strong> {{ item.tel_comercial }}</li>
                <li><strong>Celular: </strong>{{ item.celular_um }}</li>
                <li><strong>email:</strong> {{ item.email }}</li>
                <li><strong>Data Início</strong> {{ item.data_inicio | converteData }}</li>
                <li><strong>Último Lançamento</strong> {{ item.ultimo_lancamento | converteData }}</li>
              </ul>
            </b-col>
          </b-row>
        </b-list-group-item>
      </b-list-group>
    </div>
  </b-card>
</template>
<script>
import {
  BCard,
  BBadge,
  VBModal,
  BModal,
  BButton,
  BRow,
  BCol,
  BAvatar,
  BListGroup,
  BListGroupItem,
  BCardFooter,
  BDropdown,
  BDropdownItem,
  BPopover,
  VBPopover,
} from "bootstrap-vue";

import Ripple from "vue-ripple-directive";
import filtroMeses from "@/services/filtroMeses";
import filtroAnos from "@/services/filtroAnos";
import moment from "moment";



export default {
  components: {
    BCard,
    BBadge,
    BModal,
    BButton,
    BRow,
    BCol,
    BAvatar,
    BListGroup,
    BListGroupItem,
    BCardFooter,
    BDropdown,
    BDropdownItem,
    BPopover,
    VBPopover,
  },
  directives: {
    Ripple,
    "b-modal": VBModal,
    "b-popover": VBPopover,
  },
  data() {
    return {
      clicouVisualizar: false,
      clicouOrdemOs: false,
      clicouOrdemData: false,
      dias: [
        { value: 5, nome: '5 dias' },
        { value: 10, nome: '10 dias' },
        { value: 15, nome: '15 dias' },
        { value: 20, nome: '20 dias' },
      ],
      assinantes: [
        { value: 0, nome: 'Assinantes' },
        { value: 1, nome: 'Teste Gratuíto' },
      ],
      filtroDias: { valor: 5, data: '5 dias' },
      filtroAssinantes: { valor: 0, data: 'Assinantes' },
      ...filtroMeses,
      ...filtroAnos,
      filtroMeses: { valor: this.$getDate.mesAtual() , data: this.$getDate.nomeMesAtual() },
      filtroAnos: this.$getDate.anoAtual().toString(),
      items: []
    };
  },
  
  methods:{
    alterouFiltroDias(val) {
      this.filtroDias = { valor: val.value, data: val.nome }
      this.buscar()
    },
    alterouFiltroAssinantes(val) {
      this.filtroAssinantes = { valor: val.value, data: val.nome }
      this.buscar()
    },
    
    buscar() {
      this.$http.get(`adm/dashboard/inatividade-assinantes-ativos/${this.filtroDias.valor}/${this.filtroAssinantes.valor}`).then((res) => {
        this.items = res.data
      })
    }
  },
  
  mounted() {
    this.buscar()
  },
  
  filters: {
    converteData(data) {
      if (!data) return;
      
     return moment(data).format('DD/MM/YYYY')
    },
  },
  
}
</script>
<style scoped>
.listaServicos {
  max-height: 400px;
  overflow-y: scroll;
}
</style>

